import useFetchHelpCenter from './fetch/useFetchHelpCenter';

export default function useHeader() {
  const { data: helpCenter } = useFetchHelpCenter();
  const header = helpCenter?.header;
  const headerIcon = header?.header_icon;
  const headerLines = header?.lines;
  const headerTextEnabled = !!header?.header_text_enabled;
  return { headerIcon, headerLines, headerTextEnabled };
}
